module.exports = "/_next/static/images/8500e9226577ee2b7b9cb452dfe53e55-man-with-cellphone-md@2x.jpg.webp";